import React from "react";
import heart from "../../../images/green heart.png";
import "./SaveMoreStyle.css";
import Fade from "react-reveal/Fade";

const SaveMoreMsg = () => {
  return (
    <div className="container mt-5">
      <div className="text-center saveMoreContainer my-3">
        <Fade left duration={1200}>
          <h1>
            <span className="text-yellow fw-bolder">Don’t Buy!</span>{" "}
            <span className="text-blue fw-bolder">We Share!</span>{" "}
            <span style={{ color: "#03397E" }} className="fw-light">
              Save Money, Do more, Get more!
            </span>
          </h1>
        </Fade>

        <Fade left duration={1400}>
          <h1 className="mt-4">
            <span style={{ color: "#03397E" }} className="fw-light">
              Let's save the Planet!
            </span>
            <img className="greenheart" src={heart} alt="" />
          </h1>
        </Fade>
        <div>
          <div className="messageCharity">
            <Fade left duration={1600}>
              <p
                style={{ display: "inline-block" }}
                className="text-secondary text-center card-text"
              >
                10% of our profit goes to charity Your business will make a
                difference!
              </p>
            </Fade>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SaveMoreMsg;
